/**
 * 任务是否有附件
 * 格式为 taskAttach: "[{"name":"商品协议价导出数据.xlsx","url":"http://test-img.csxqyg.com.cn/excels/20200602/56C7D40BF5624E0F8B76753771568FC9.xlsx"}]"
 * @param {string} attach 任务附件
 */
export function hasAttach(attach) {
  let res;
  try {
    res = attach ? JSON.parse(attach) : [];
    if (!Array.isArray(res) || res.length === 0) {
      return false;
    }
    // 只有附件为数组并且有 url 时才认为有附件
    if (!res[0].url) {
      return false;
    }
  } catch (error) {
    return false;
  }
  return true;
}

/* interface ITaskAttach {
  name: string;
  url: string;
}

type ITaskAttachType = ITaskAttach | false; */

/**
 * 获取任务附件
 * 格式为 taskAttach: "[{"name":"商品协议价导出数据.xlsx","url":"http://test-img.csxqyg.com.cn/excels/20200602/56C7D40BF5624E0F8B76753771568FC9.xlsx"}]"
 * @param {string} attach 任务附件
 */
export function getAttach(taskAttach) {
  try {
    const taskAttachArr = taskAttach ? JSON.parse(taskAttach) : [];
    if (Array.isArray(taskAttachArr) && taskAttachArr.length) {
      return taskAttachArr[0];
    }
  } catch (error) {
    return false;
  }
  return false;
}

/**
 * 从 taskData 字段中获取任务状态
 * @param {string} taskData 任务
 * @returns 0表示正常,1 表示异常,使用红色进度条
 */
export function getTaskStatus(taskData) {
  try {
    const data = taskData ? JSON.parse(taskData) : {};
    return data.status;
  } catch (error) {
    return null;
  }
}
